export default __webpack_public_path__ + "static/media/love.105494fa.png";